import { Link } from 'react-router-dom'

const S = ({ n, title, children }: { n: string; title: string; children: React.ReactNode }) => (
  <div style={{ marginBottom: 32 }}>
    <h2 style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: '.92rem', color: 'var(--bill)', marginBottom: 10, paddingBottom: 8, borderBottom: '1px solid var(--edge)' }}>
      {n}. {title}
    </h2>
    <div style={{ fontFamily: 'Space Grotesk', fontSize: '.82rem', color: 'var(--muted)', lineHeight: 1.85 }}>
      {children}
    </div>
  </div>
)
const P = ({ children, style }: { children: React.ReactNode; style?: React.CSSProperties }) => <p style={{ marginBottom: 10, ...style }}>{children}</p>
const Ul = ({ items }: { items: string[] }) => (
  <ul style={{ paddingLeft: 18, display: 'flex', flexDirection: 'column', gap: 5, margin: '6px 0' }}>
    {items.map(i => <li key={i} style={{ lineHeight: 1.65 }}>{i}</li>)}
  </ul>
)

export default function Disclaimer() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--ink)', paddingBottom: 80 }}>
      <div style={{ borderBottom: '1px solid var(--edge)', padding: '14px 24px', display: 'flex', alignItems: 'center', gap: 16 }}>
        <Link to="/" style={{ fontFamily: 'Syne', fontWeight: 900, fontSize: '1rem', color: 'var(--cash)', textDecoration: 'none', letterSpacing: '-0.03em' }}>Polywally</Link>
        <span style={{ color: 'var(--edge)' }}>·</span>
        <span style={{ fontFamily: 'Syne Mono', fontSize: '.6rem', color: 'var(--muted)', letterSpacing: '.1em', textTransform: 'uppercase' }}>Disclaimer</span>
      </div>

      <div style={{ maxWidth: 680, margin: '0 auto', padding: '52px 24px 0' }}>
        <div style={{ marginBottom: 44 }}>
          <h1 style={{ fontFamily: 'Syne', fontWeight: 900, fontSize: '2rem', color: 'var(--bill)', letterSpacing: '-0.03em', lineHeight: 1.1, marginBottom: 12 }}>Disclaimer</h1>
          <div style={{ fontFamily: 'Syne Mono', fontSize: '.6rem', color: 'var(--muted)', opacity: .6 }}>
            Last updated: February 2026 · Polywally
          </div>
        </div>

        <div style={{ background: 'rgba(224,92,92,.06)', border: '1px solid rgba(224,92,92,.25)', borderLeft: '3px solid var(--red)', borderRadius: 3, padding: '14px 16px', marginBottom: 36, fontFamily: 'Space Grotesk', fontSize: '.82rem', color: 'var(--text)', lineHeight: 1.75 }}>
          <strong>Polywally is not a registered investment advisor, broker-dealer, or financial institution.</strong> Nothing on this platform constitutes investment advice or a recommendation to buy, sell, or hold any security. All users act at their own risk.
        </div>

        <S n="1" title="Educational Purpose Only">
          <P>Polywally provides AI-generated technical analysis for educational purposes only. It is designed to help users learn ICT and Smart Money Concepts — not to provide trading signals or financial advice.</P>
          <P>Grades, directional labels, entry zones, stop loss levels, and profit targets are illustrative examples of how ICT/SMC concepts may apply to a given chart. They are not recommendations to enter or exit any position.</P>
          <P>Always conduct your own research or consult a licensed financial advisor before making any investment decision.</P>
        </S>

        <S n="2" title="AI Analysis Limitations">
          <P>AI-generated analysis may:</P>
          <Ul items={[
            'Misread price levels, patterns, or chart elements',
            'Not account for fundamental data, news, or macroeconomic factors',
            'Produce inconsistent results for the same chart at different times',
          ]} />
          <P style={{ marginTop: 10 }}>Never use AI analysis as your sole basis for a financial decision.</P>
        </S>

        <S n="3" title="Paper Trading">
          <P>The paper trading feature connects to Alpaca Securities' simulated environment. No real money is involved. Simulated results do not reflect actual trading outcomes and may differ materially due to slippage, liquidity, and real-world market conditions.</P>
          <P>Polywally is not affiliated with Alpaca Securities LLC and assumes no responsibility for their platform, data, or execution.</P>
        </S>

        <S n="4" title="Limitation of Liability">
          <P>Polywally is provided "as is" without warranty of any kind. To the fullest extent permitted by law, Polywally and its operators are not liable for any losses, damages, or financial decisions made based on content or analysis generated by this platform.</P>
        </S>

        <div style={{ marginTop: 48, paddingTop: 24, borderTop: '1px solid var(--edge)', display: 'flex', gap: 20, flexWrap: 'wrap', fontFamily: 'Syne Mono', fontSize: '.6rem' }}>
          <Link to="/" style={{ color: 'var(--cash)', textDecoration: 'none' }}>← Back to Polywally</Link>
          <Link to="/terms" style={{ color: 'var(--muted)', textDecoration: 'none' }}>Terms of Service</Link>
          <Link to="/privacy" style={{ color: 'var(--muted)', textDecoration: 'none' }}>Privacy Policy</Link>
        </div>
      </div>
    </div>
  )
}
